'use client';

import FaIcon, { faClock } from '@/components/icon/FaIcon/FaIcon';
import { PITY_LABEL_STATUS, WCHANCE_LABEL_STATUS } from '@/constants';
import { Format } from '@/lib/dateFns';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { newDate } from '@/utils/date';
import { formatDateCommon } from '@/utils/formatters';
import { isAfter, isBefore } from 'date-fns';
import type React from 'react';
import type { LotteryDrawHistoryLineup, PityItem, PityLabel } from '../../types';
import LotteryGoodsList from '../LotteryGoodsList/LotteryGoodsList';
import PityHeader from '../PityHeader/PityHeader';
import styles from './PityCard.module.scss';

function PityCard({
  pityItem,
  lotteryDrawHistory,
}: {
  pityItem: PityItem;
  lotteryDrawHistory: Array<LotteryDrawHistoryLineup>;
}) {
  const labelIsFinish = (label: PityLabel, labelStatusText: string) =>
    isAfter(newDate(), newDate(label.endAt ?? '')) || labelStatusText === WCHANCE_LABEL_STATUS.sold_out.text;
  return (
    <div className={styles.componentStyle}>
      <PityHeader name={pityItem.count.toString()} />

      {pityItem.labels.map((label: PityLabel, index: number) => {
        const labelStatus = pityLabelStatus(label);
        return (
          <div key={label.id}>
            <hr className={index > 0 ? styles.hr : styles.top} />
            <div className={styles.labelItem}>
              {labelIsFinish(label, labelStatus.text) && <div className={styles.mask} />}
              <div className={styles.statusWrapper}>
                {/* 表示調整用 */}
                <div />
                <div className={styles.statusLabel} style={statusLabelStyle(labelStatus.color)}>
                  {labelStatus.text}
                </div>
              </div>
              <div className={`${styles.dateWrapper} ${utilsStyles.textBold}`}>{term(label)}</div>
              <div className={styles.title}>{label.name}</div>
              <div className={styles.detailArea}>
                <p className={styles.labelDescription}>{label.description}</p>
              </div>
              {/* 景品一覧 */}
              <LotteryGoodsList
                goodsList={label.goods}
                linupId={label.id}
                liKeyPrefix={'prize_goods'}
                lotteryStatus={labelStatus.text}
                lotteryDrawHistory={lotteryDrawHistory}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

function term(label: PityLabel) {
  if (label.startAt === null && label.endAt === null) {
    return <></>;
  }
  return (
    <>
      <div className={styles.dateIcon}>
        <FaIcon icon={faClock} />
      </div>
      <span>
        &nbsp;
        {label.startAt && formatDateCommon(label.startAt, Format.dateTimeLotteryJa)}
        &nbsp;~&nbsp;
        {label.endAt && formatDateCommon(label.endAt, Format.dateTimeLotteryJa)}
      </span>
    </>
  );
}

function pityLabelStatus(label: PityLabel) {
  //開催中
  if (!label.startAt && !label.endAt) {
    return PITY_LABEL_STATUS.is_session;
  }
  // 開始前
  if (label.startAt && isBefore(newDate(), newDate(label.startAt))) return PITY_LABEL_STATUS.soon_start;
  // 終了
  if (label.endAt && isAfter(newDate(), newDate(label.endAt))) return PITY_LABEL_STATUS.finish;

  //開催中
  if (label.startAt && label.endAt && isBefore(newDate(), newDate(label.endAt))) {
    return PITY_LABEL_STATUS.is_session;
  }
  if (label.startAt && label.endAt && isAfter(newDate(), newDate(label.startAt))) {
    return PITY_LABEL_STATUS.is_session;
  }

  return PITY_LABEL_STATUS.default;
}

function statusLabelStyle(color: string) {
  return {
    backgroundColor: `var(--color-${color})`,
  };
}

export default PityCard;
